import { Component, Input } from '@angular/core';
import { IconType } from '@ng-icons/core';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.css'
})
export class DashboardCardComponent {
  @Input() public title: string;
  @Input() public iconName: string;
  @Input() public iconPath: string;
  @Input() public iconColor: string;
  @Input() public bgColor: string;
  @Input() public vectorPath: string;
}
